import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        content: {
        },
        table: {
            flexGrow: 1,
            minWidth: '60%',
        },
        nextButton: {
            paddingTop: theme.spacing(2),
            alignSelf: 'flex-end',
            marginRight: '20%',
        },
        formControllers: {
            display: 'flex',
            minWidth: '61%',
            justifyContent: 'space-between',
            alignItems: 'center',
            alignContent: 'flex-end',
            marginBottom: theme.spacing(1),
        },
        outButton: {
            backgroundColor: 'white',
            color: 'grey[400],'
        },
        chipButton: {
            backgroundColor: 'transparent',
            border: 'none',
        },
        chip: {
            color: 'grey[50]',
        },
    })
);